//App.js

import React from 'react'
import SortingVis from './components/SortingVis/SortingVis'

//App component renders the main SortingVis component
export default class App extends React.Component {
        render() {
                return <SortingVis />
        }
}